module.exports = __webpack_public_path__ + "img/classify-list-3.d36f10da.png";